/* sp-video.js — <sp-video-carousel>: scroll-snap card slider (arrows / dots / drag; same page math as
   sp-card-slider.js) plus a poster play button for <video> cards (one card plays at a time). No UI text:
   labels come from Liquid (sp.video.* locale keys). */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class SpVideoCarousel extends HTMLElement {
    connectedCallback() {
      if (this.spReady) return;
      this.track = this.querySelector('[data-sp-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-sp-slide]'));
      if (!this.track || !this.slides.length) return;
      this.spReady = true;
      this.prev = this.querySelector('[data-sp-prev]');
      this.next = this.querySelector('[data-sp-next]');
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-sp-dot]'));
      this.index = 0;
      this.pages = 1;
      if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.index - 1));
      if (this.next) this.next.addEventListener('click', () => this.goTo(this.index + 1));
      this.dots.forEach((d) => {
        d.addEventListener('click', () => this.goTo(parseInt(d.getAttribute('data-sp-dot'), 10) || 0));
      });
      var scrollTimer;
      this.track.addEventListener(
        'scroll',
        () => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => this.syncFromScroll(), 80);
        },
        { passive: true }
      );
      this.onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.update(), 120);
      };
      window.addEventListener('resize', this.onResize);
      this.initPlayers();
      this.update();
    }

    disconnectedCallback() {
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    /* ---------- slider ---------- */

    perPage() {
      var w = this.track.clientWidth;
      var first = this.slides[0];
      if (!first) return 1;
      var sw = first.getBoundingClientRect().width;
      var step = this.slides.length > 1 ? this.slides[1].offsetLeft - first.offsetLeft : sw;
      if (sw <= 0 || step <= 0) return 1;
      return Math.max(1, Math.floor((w + (step - sw) + 1) / step));
    }

    update() {
      this.pages = Math.max(1, this.slides.length - this.perPage() + 1);
      this.classList.toggle('is-single', this.pages <= 1);
      this.dots.forEach((d, k) => {
        var li = d.parentElement;
        if (li) li.classList.toggle('is-hidden', k >= this.pages);
      });
      this.setActive(Math.min(this.index, this.pages - 1));
    }

    goTo(i) {
      i = Math.max(0, Math.min(this.pages - 1, i));
      var slide = this.slides[i];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      this.setActive(i);
    }

    syncFromScroll() {
      var x = this.track.scrollLeft;
      var best = 0;
      var bd = Infinity;
      this.slides.forEach((s, k) => {
        var d = Math.abs(s.offsetLeft - this.track.offsetLeft - x);
        if (d < bd) {
          bd = d;
          best = k;
        }
      });
      this.setActive(Math.min(best, this.pages - 1));
    }

    setActive(i) {
      this.index = i;
      this.dots.forEach((d, k) => {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      if (this.prev) this.prev.disabled = i <= 0;
      if (this.next) this.next.disabled = i >= this.pages - 1;
    }

    /* ---------- players ---------- */

    initPlayers() {
      var videos = Array.prototype.slice.call(this.querySelectorAll('video'));
      var pauseOthers = function (current) {
        videos.forEach(function (v) {
          if (v !== current && !v.paused) v.pause();
        });
      };
      this.slides.forEach(function (slide) {
        var video = slide.querySelector('video');
        var play = slide.querySelector('[data-sp-play]');
        if (!video) {
          if (play) play.hidden = true;
          return;
        }
        if (play) {
          play.addEventListener('click', function () {
            pauseOthers(video);
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          });
        }
        video.addEventListener('play', function () {
          pauseOthers(video);
          slide.classList.add('is-playing');
        });
        video.addEventListener('pause', function () {
          slide.classList.remove('is-playing');
        });
        video.addEventListener('ended', function () {
          slide.classList.remove('is-playing');
        });
      });
    }
  }

  if (!customElements.get('sp-video-carousel')) customElements.define('sp-video-carousel', SpVideoCarousel);
})();
